import { upperFirst } from 'lodash';
import React from 'react';

import withAppointmentNotification from '../../../hoc/withAppointmentNotification';
import AppointmentInfo from '../../../shared/FlagshipAppointmentInfo';
import NotificationContent from '../../../shared/FlagshipNotification';
import FlagshipRescheduleOrCancel from '../../../shared/FlagshipRescheduleOrCancel';
import FlagshipSharedBottom from '../../../shared/FlagshipSharedBottom';
import ShopLocation from '../../../shared/FlagshipShopLocation';
import Header from '../components/Header';
import Helmets from '../components/Helmets';
import ColorBar from '../components/ColorBar';
import Footer from '../components/Footer';

/* eslint-disable react/prop-types */
const FlagshipAppointmentCancelled = ({
  shop,
  date,
  customer,
  barber,
  confirmationCode,
  service,
  duration,
  address,
  appLink,
  iosLink,
  androidLink,
  reservationLink,
}) => (
  <div>
    <Helmets />

    <Header>Hey {upperFirst(customer.firstName)}, your appointment was cancelled.</Header>

    <NotificationContent>
      <ColorBar color="#FF3B30" />

      <h2 className="u-text-huge u-fw-bold u-mt-12 u-mb-10 u-hide-breaks-on-mobile">
        {/* eslint-disable quotes */}
        Hey {upperFirst(customer.firstName)}, your appointment{` `}
        <br />
        has been cancelled.
        {/* eslint-enable quotes */}
      </h2>
      <div className="u-text-extrasmall u-fw-bold u-tt-uppercase u-co-grey u-mb-4">Cancelled appointment</div>
      <div className="u-flex u-justify-content-space-between u-flex-wrap u-align-stretch">
        <AppointmentInfo
          confirmationCode={confirmationCode}
          barberName={`${barber.firstName} ${(barber.lastName || '')[0]}.`}
          service={service}
          date={date}
          duration={duration}
          customerName={`${customer.firstName} ${(customer.lastName || '')[0]}.`}
          className="cancelled"
        >
          <a href={appLink} className="flgshp-button u-mt-6">
            Book again
          </a>
        </AppointmentInfo>
        <ShopLocation
          shopName={shop.name}
          phone={shop.phone}
          line1={address.line1}
          line2={address.line2}
          map={shop.staticMap ? shop.staticMap.url : ''}
          directions={address.directions}
        />
      </div>
      {shop.mobileAppCta && (
        <FlagshipRescheduleOrCancel appLink={appLink} androidLink={androidLink} iosLink={iosLink} />
      )}
      <FlagshipSharedBottom reservationLink={reservationLink} shopName={shop.name} />
    </NotificationContent>
    <Footer link={appLink} />
  </div>
);

export default withAppointmentNotification(FlagshipAppointmentCancelled);



// WEBPACK FOOTER //
// ./src/app/notifications/customer/Flagship/CustomerAppointmentCancelled/index.jsx